import useSWR from 'swr';
import * as _ from 'lodash';
import { getPortalAnalytics } from '../services/portal';
import { analyticsDataToFrontendFormat } from '../services/analytics';

export function useAnalytics(clientsBoardId?: number) {
  let {
    data: analyticsData,
    isLoading,
    error,
  } = useSWR(
    clientsBoardId ? `/analytics/${clientsBoardId}` : null,
    async () => {
      if (!clientsBoardId) {
        return null;
      }

      return getPortalAnalytics(clientsBoardId);
    },
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
    },
  );

  return {
    analyticsData: analyticsData ? analyticsDataToFrontendFormat(analyticsData) : undefined,
    isLoading,
    error,
  };
}
